import { render, staticRenderFns } from "./SelectGameType.vue?vue&type=template&id=dc9eedc2"
import script from "./SelectGameType.vue?vue&type=script&lang=js"
export * from "./SelectGameType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports